import { Link } from 'react-router-dom';
import { useTranslation } from '../../../i18n/i18n';
import { ApiProduct } from '../../../types';
import { Img } from '../../Img/Img';
import { Button } from '../../Form/Button';
import { PriceTagSimple } from '../../PriceTagSimple/PriceTagSimple';
import './HorizontalProductCardSpecialPrice.css';

export const HorizontalProductCardSpecialPrice = ({
	product,
	newPrice,
	handleOnClick,
	lockable,
}: {
	product: ApiProduct;
	newPrice: number;
	handleOnClick: (action: 'accept', product: ApiProduct) => void;
	lockable?: boolean;
}): JSX.Element => {
	const t = { ...useTranslation().product, ...useTranslation().specialPrices };
	const { displayId: _displayId, name, image, perma, price, campaignPrice, vatRate, sku } = product;

	return (
		<>
			<div className="row special-price">
				<div className="product-image">
					<Link to={'/' + perma} target="_blank">
						<Img src={image} width={50} height={50} imgWidth={50} imgHeight={50} alt={name} />
					</Link>
				</div>
				<div className="product-details-wrapper">
					<div className="product-link">
						<Link to={'/' + perma} target="_blank">
							{name}
						</Link>
					</div>
					<div className="article-number">
						{t.articleNumber} {sku}
					</div>
					<div className="price not-mobile">
						<p>{t.orginalPrice}</p>
						<PriceTagSimple price={price} vatRate={vatRate}></PriceTagSimple>
					</div>
					{lockable && (
						<>
							<div className="not-mobile">
								<div className="price">
									<p>{t.yourPrice}</p>
									<PriceTagSimple price={newPrice} vatRate={vatRate} isCampaign></PriceTagSimple>
								</div>
							</div>
							<div className="buy-button not-mobile">
								<Button className="buy-button" onClick={() => handleOnClick('accept', product)}>
									{t.acceptPrice2}
								</Button>
							</div>
						</>
					)}
				</div>
			</div>
			<div className="row-bottom special-price only-mobile">
				<div className="product-details row-bottom">
					<div className="price-column">
						<div className="original-price">
							<p>{t.orginalPrice}</p>
							<PriceTagSimple
								price={price}
								vatRate={vatRate}
								isCampaign={campaignPrice > 0}
							></PriceTagSimple>
						</div>
						{lockable && (
							<div className="your-price">
								<p>{t.yourPrice}</p>
								<PriceTagSimple price={newPrice} vatRate={vatRate}></PriceTagSimple>
							</div>
						)}
					</div>
					{lockable && (
						<div className="accept-price-button">
							<Button className="buy-button" onClick={() => handleOnClick('accept', product)}>
								{t.acceptPrice2}
							</Button>
						</div>
					)}
				</div>
			</div>
		</>
	);
};
